import Vue from 'vue'
import Loader from '@/components/Loader'
import LoaderContainer from '@/components/LoaderContainer'
import InfoMessage from '@/components/InfoMessage'
import Icon from '@/components/Icon'
import PageHeader from '@/components/PageHeader'
import Panel from '@/components/Panel'
import Lists from '@/components/Lists'
import ListItem from '@/components/ListItem'
import Table from '@/components/Table'
import TableWrapper from '@/components/TableWrapper'
import SearchBar from '@/components/SearchBar'
import Tabs from '@/components/Tabs'
import CmsGallery from '@/components/CmsGallery'
import PhotoGallery from '@/components/PhotoGallery'
import CmsVideoUpload from '@/components/CmsVideoUpload'
import AssetVideo from '@/components/AssetVideo'
import ValuationVideoUpload from '@/components/ValuationVideoUpload'
import TabulatedPages from '@/components/TabulatedPages'
import TabulatedControls from '@/components/TabulatedControls'
import NotificationList from '@/components/NotificationList'
import Modal from '@/components/Modal'
import NetworkAlertsPopup from '@/components/NetworkAlertsPopup'
import Calendar from '@/components/Dashboard/Calendar'
import EventList from '@/components/Dashboard/EventList'
import Select from '@/components/Select'
import SelectInput from '@/components/SelectInput'
import ToggleInput from '@/components/ToggleInput'
import TwitterFeed from '@/components/TwitterFeed'
import Editor from '@/components/cms/Editor'
import Paginator from '@/components/Paginator'
import MediaManager from '@/components/MediaManager'
import ApsTrigger from '@/components/AutoProspecting/ApsTrigger'
import ApsTemplateModal from '@/components/AutoProspecting/ApsTemplateModal'
import ResponsiveSecondaryMenu from './components/ResponsiveSecondaryMenu'
import { Chrome } from 'vue-color'
import LeadProStatus from '@/components/LeadProStatus'
import LeadProStatusOfficeBased from '@/components/LeadProStatusOfficeBased'
import MovebutlerSSO from '@/components/MovebutlerSSO'
import NurturSSO from '@/components/NurturSSO'
import OfficeLandRegistryData from '@/components/LandRegistryData/OfficeLandRegistryData'
import QrCodeSetting from '@/components/digital-hub/QrCodeSetting'
import GrsRegistrationModal from '@/components/Referrals/GrsRegistrationModal'
import SelectInputComponent from '@/components/SelectInputComponent'
import CheckboxInputComponent from '@/components/CheckboxInputComponent'
import TextInputComponent from '@/components/FormElements/TextInputComponent'
import DatePickerComponent from '@/components/FormElements/DatePickerComponent'
import TextareaInputComponent from '@/components/FormElements/TextareaInputComponent'
import UploadDropzoneComponent from '@/components/FormElements/UploadDropzoneComponent'
import TagInputComponent from '@/components/forms/TagInputComponent'

Vue.component('loader', Loader)
Vue.component('loader-container', LoaderContainer)
Vue.component('info-msg', InfoMessage)
Vue.component('icon', Icon)
Vue.component('page-header', PageHeader)
Vue.component('panel', Panel)
Vue.component('list', Lists)
Vue.component('list-item', ListItem)
Vue.component('vue-table', Table)
Vue.component('table-wrapper', TableWrapper)
Vue.component('search-bar', SearchBar)
Vue.component('tabs', Tabs)
Vue.component('cms-gallery', CmsGallery)
Vue.component('photo-gallery', PhotoGallery)
Vue.component('cms-video', CmsVideoUpload)
Vue.component('asset-video', AssetVideo)
Vue.component('valuation-video', ValuationVideoUpload)
Vue.component('tabulated-pages', TabulatedPages)
Vue.component('tabulated-controls', TabulatedControls)
Vue.component('notification-list', NotificationList)
Vue.component('modal', Modal)
Vue.component('network-alerts-popup', NetworkAlertsPopup)
Vue.component('calendar-widget', Calendar)
Vue.component('event-list-widget', EventList)
Vue.component('pl-select', Select)
Vue.component('select-input', SelectInput)
Vue.component('twitter-timeline', TwitterFeed)
Vue.component('editor', Editor)
Vue.component('paginator', Paginator)
Vue.component('media-manager', MediaManager)
Vue.component('aps-trigger', ApsTrigger)
Vue.component('aps-modal', ApsTemplateModal)
Vue.component('responsive-secondary-menu', ResponsiveSecondaryMenu)
Vue.component('chrome-picker', Chrome)
Vue.component('leadPro-status', LeadProStatus)
Vue.component('leadPro-status-office-based', LeadProStatusOfficeBased)
Vue.component('movebutler-single-sign-on', MovebutlerSSO)
Vue.component('nurtur-single-sign-on', NurturSSO)
Vue.component('office-land-registry-data', OfficeLandRegistryData)
Vue.component('qr-code-setting', QrCodeSetting)
Vue.component('grs-registration-modal', GrsRegistrationModal)
Vue.component('select-input', SelectInputComponent)
Vue.component('checkbox-input', CheckboxInputComponent)
Vue.component('text-input', TextInputComponent)
Vue.component('date-picker-input', DatePickerComponent)
Vue.component('textarea-input', TextareaInputComponent)
Vue.component('upload-dropzone-component', UploadDropzoneComponent)
Vue.component('toggle-input', ToggleInput)
Vue.component('tag-input', TagInputComponent)
